__turbopack_context__.v({
  "rect": "index-module-scss-module__G6bJzG__rect",
  "stars": "index-module-scss-module__G6bJzG__stars",
});
